import React, { Component } from "react";
import { Radio, Card } from "antd";
import CasesChart from "../enterprise/landscape/field-agg";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { LANDSCAPE_DEFAULTS } from "../../helpers/defaults";

const styles = {
  cardContent: {
    width: "100%",
    padding: "8px 0 0 0",
    textAlign: "center"
  },
  verticalGutter: {
    marginTop: 16
  }
};

const QUERY_MAPPING = {
  hevc_v4: LANDSCAPE_DEFAULTS["hevc"].filters.v4,
  avc_v1: LANDSCAPE_DEFAULTS["avc"].filters.v1,
  lte_v3: LANDSCAPE_DEFAULTS["lte"].filters.v3,
  "5g_v2": LANDSCAPE_DEFAULTS["5g"].filters.v2
};
const VERSION_MAPPING = {
  hevc_v4: LANDSCAPE_DEFAULTS["hevc"].fields.v4,
  avc_v1: LANDSCAPE_DEFAULTS["avc"].fields.v1,
  lte_v3: LANDSCAPE_DEFAULTS["lte"].fields.v3,
  "5g_v2": LANDSCAPE_DEFAULTS["5g"].fields.v2
};

const pathGenerator = esIndex => "/standards/opal/" + esIndex.replace("_", "/");
const queryToFilter = query => {
  return {
    alpha_score: `${query.alpha_threshold}--`,
    type: query.count_by === "grant" ? "Grant" : undefined,
    pools: query.pools,
    publication_status: query.pub_status
  };
};

class StackedBarChart extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string
      })
    ),
    esUrlBase: PropTypes.string,
    field: PropTypes.string,
    flag: PropTypes.string,
    extra: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  state = {
    esIndex: this.props.options[0].value
  };
  render() {
    const { options, esUrlBase, field, flag, extra } = this.props;
    const esUrl = `${esUrlBase}/patents/v6/_search`;
    const filter = queryToFilter(QUERY_MAPPING[this.state.esIndex]);
    const view = QUERY_MAPPING[this.state.esIndex] && QUERY_MAPPING[this.state.esIndex].count_by === "family" ? "family" : "pub";
    const tickFormatY = label => (label.length > 15 ? `${label.slice(0, 15)}...` : label);
    return (
      <Card title={flag} extra={extra} bodyStyle={styles.cardContent} style={styles.verticalGutter}>
        <Radio.Group value={this.state.esIndex} onChange={e => this.setState({ esIndex: e.target.value })}>
          {options.map((opt, i) => (
            <Radio.Button value={opt.value} key={i}>
              {opt.label}
            </Radio.Button>
          ))}
        </Radio.Group>
        <div style={{ width: "100%", overflow: "auto" }}>
          <CasesChart
            view={view}
            field={field}
            size={10}
            esUrl={esUrl}
            version={VERSION_MAPPING[this.state.esIndex]}
            filter={filter}
            onSelectBar={v => this._onMergeQueryString(v)}
            tickFormatY={tickFormatY}
            margin={{ left: 40, right: 16, top: 40, bottom: 16 }}
            exportable={false}
          />
        </div>
      </Card>
    );
  }

  _onMergeQueryString = qsObj => {
    this.props.router.push({
      pathname: pathGenerator(this.state.esIndex),
      query: {
        ...QUERY_MAPPING[this.state.esIndex],
        ...qsObj
      }
    });
  };
}

export default withRouter(StackedBarChart);
